export const blockIconsDeviceBatteryFull = (
	<span className='material-symbols-outlined'>battery_full</span>
);
